var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FirstStep',{attrs:{"companyDropdownItems":_vm.companyDropdownItems,"processOrderDropdownItems":_vm.processOrdersDropdownItems,"selectedProcessOrder":_vm.selectedProcessOrder,"selectedCompany":_vm.selectedCompany},on:{"update:companyId":_vm.updateCompanyId,"update:processOrderId":_vm.updateProcessOrderId}})
}
var staticRenderFns = []

export { render, staticRenderFns }